import React from 'react';
import { CampaignDetailsList, ParentColumnPlacement } from '@bingads-webui-grid/campaign-details-list';

export const useDetailList = () => {
  const renderDetailsList = ({
    pagedItems, onSort, toolbar, pager, columns, sortByColumn, expandColumns,
  }) => (
    <CampaignDetailsList
      skipViewportMeasures={false}
      items={pagedItems}
      columns={columns}
      sortedColumn={sortByColumn}
      onSort={onSort}
      toolbar={toolbar}
      stickyHeader
      pager={pager}
      subColumnProps={{
        showSubColumns: true,
        parentColumnPlacement: ParentColumnPlacement.Left,
        expandIconName: 'Add',
        collapseIconName: 'Remove',
      }}
      role="main"
      withCustomizedSortIcon
      alignWithCampaignUI
      onUpdateColumns={(newColumns) => {
        expandColumns(newColumns);
      }}
    />
  );

  return { renderDetailsList };
};
